export const deleteMessagesModalCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  successToast: '',
};
